import { createBlock } from "./campaignBlocks";

const HERO = {
  birthday:
    "https://firebasestorage.googleapis.com/v0/b/fidduxai-rowy.appspot.com/o/email_assets%2Fpresets%2Fhero-birthday.jpg?alt=media&token=96dbfa82-e2b8-4a79-88ed-80eb30bcd20c",
  christmas:
    "https://firebasestorage.googleapis.com/v0/b/fidduxai-rowy.appspot.com/o/email_assets%2Fpresets%2Fhero-christmas.jpg?alt=media&token=f5e881a6-5f6a-4324-8685-9e7ee3fb989d",
  newYear:
    "https://firebasestorage.googleapis.com/v0/b/fidduxai-rowy.appspot.com/o/email_assets%2Fpresets%2Fhero-new-year.jpg?alt=media&token=0eecf9e1-4c23-4ee2-a073-4b820421b98b",
  cny:
    "https://firebasestorage.googleapis.com/v0/b/fidduxai-rowy.appspot.com/o/email_assets%2Fpresets%2Fhero-cny.jpg?alt=media&token=5b692d1f-a00e-43c9-8aea-18fb07c8274e",
  easter:
    "https://firebasestorage.googleapis.com/v0/b/fidduxai-rowy.appspot.com/o/email_assets%2Fpresets%2Fhero-easter.jpg?alt=media&token=3bd16382-f7e1-44c3-a3d7-5e812f3b0c27",
  yearEnd:
    "https://firebasestorage.googleapis.com/v0/b/fidduxai-rowy.appspot.com/o/email_assets%2Fpresets%2Fhero-year-end.jpg?alt=media&token=85781ce4-266d-4409-bb52-528ba3968a10",
};

function withIds(blocks) {
  return blocks.map((b) => ({ ...createBlock(b.type), ...b, id: createBlock(b.type).id }));
}

const CAPITAL_ROUTING_FOOTER_NOTE =
  "<p style=\"font-size:11px;color:#888888;margin:0;\">Settlement may take 2-3 business days; account performance during the process may be subject to differentiation.</p>";

export const CAMPAIGN_PRESETS = [
  {
    id: "capital_routing_information_required",
    label: "Capital Routing — Information Required",
    description:
      "Reply to a client's initial routing request. Ask for full details and written confirmations before opening the case. Manual send only.",
    subject: "Your Internal Capital Routing Request — Information Required",
    eyebrow: "COMPLIANCE",
    blocks: withIds([
      { type: "greeting", enabled: true },
      {
        type: "heading",
        eyebrow: "",
        title: "Internal capital routing — information required",
        lead:
          "Thank you for contacting Fiddux regarding an internal capital routing between Fiddux accounts.",
      },
      {
        type: "text",
        html: "<p>Please note that internal capital routing is a manually reviewed, compliance-controlled operation. It is not an automated feature and is processed on a case-by-case basis. To open your case, please reply to this email with the following information:</p>",
      },
      {
        type: "section",
        title: "Information we need",
        html: "<ol><li><strong>Sender (you):</strong> full legal name and the email registered on your Fiddux account.</li><li><strong>Recipient:</strong> full legal name and the email registered on their Fiddux account.</li><li><strong>Amount</strong> to be routed (in USDT).</li><li>Your <strong>relationship</strong> to the recipient.</li><li><strong>Purpose</strong> of the routing.</li></ol>",
      },
      {
        type: "section",
        title: "Please confirm in writing",
        html: "<ul><li>The operation is subject to manual compliance review and is not instantaneous.</li><li>The information provided is accurate and the funds are of legitimate origin.</li><li>You authorise Fiddux to debit the stated amount from your account and credit it to the recipient's account upon completion of the review.</li></ul>",
      },
      {
        type: "text",
        html: "<p>Your case will only be opened once all of the above has been received. Incomplete requests cannot be processed.</p><p>Kind regards,<br/>Fiddux Compliance</p>",
      },
      { type: "note", html: CAPITAL_ROUTING_FOOTER_NOTE },
    ]),
  },
  {
    id: "capital_routing_under_review",
    label: "Capital Routing — Under Review",
    description:
      "After the client returns complete information. Acknowledge receipt and set expectations before executing routing in the admin wizard.",
    subject: "Your Internal Capital Routing Request — Under Review",
    eyebrow: "COMPLIANCE",
    blocks: withIds([
      { type: "greeting", enabled: true },
      {
        type: "heading",
        eyebrow: "",
        title: "Your request is under review",
        lead: "We confirm receipt of the complete information for your internal capital routing request.",
      },
      {
        type: "text",
        html: "<p>Your case has now entered manual compliance review. This process requires additional verification and is handled with the diligence such operations demand; it is not immediate. We will contact you should any further information or clarification be required.</p><p>No further action is required from you at this stage. We appreciate your patience while we complete the necessary checks.</p><p>Kind regards,<br/>Fiddux Compliance</p>",
      },
      { type: "note", html: CAPITAL_ROUTING_FOOTER_NOTE },
    ]),
  },
  {
    id: "capital_routing_discrepancy_declined",
    label: "Capital Routing — Cancelled and Closed",
    description:
      "Cancel the request when the account named in the original routing request does not match the account named in the details the client later sent. Closes the case. Manual send only.",
    subject: "Your Internal Capital Routing Request — Cancelled and Closed",
    eyebrow: "COMPLIANCE",
    blocks: withIds([
      { type: "greeting", enabled: true },
      {
        type: "heading",
        eyebrow: "",
        title: "This request cannot proceed",
        lead:
          "We have reviewed your request for an internal capital routing together with the details you subsequently sent by email.",
      },
      {
        type: "facts",
        items: [
          {
            label: "Request status",
            value: "Cancelled and closed",
            note: "Capital routing",
          },
        ],
      },
      {
        type: "section",
        title: "Why this request is cancelled and closed",
        html: "<p>The Fiddux account identified in your original request does not correspond to the account identified in the information you later provided. The two submissions refer to different accounts.</p><p>Internal capital routing is a manually reviewed, compliance-controlled operation. It can proceed only when the request and the supporting details identify the same account, without discrepancy. Where they do not, the request cannot be processed.</p><p>No funds will be debited from, or credited to, any Fiddux account in connection with this request.</p>",
      },
      {
        type: "text",
        html: "<p>Should you wish to route capital between Fiddux accounts, please submit a new request in which the account and every detail you provide are consistent with one another. We will review a complete submission that is free of discrepancy.</p><p>Kind regards,<br/>Fiddux Compliance</p>",
      },
    ]),
  },
  {
    id: "brazil_exchange_balances_oct2026",
    label: "Brazil crypto reporting, 1 October 2026",
    description:
      "General regulatory note for clients with assets at exchanges in Brazil. Portuguese version linked at the top. Do not send until approved.",
    subject: "Crypto asset reporting in Brazil: changes from 1 October 2026",
    eyebrow: "REGULATORY UPDATE",
    blocks: withIds([
      {
        type: "note",
        html: "<p><a href=\"https://fiddux.com/comunicados/cripto-brasil-outubro-2026.html\">Leia este comunicado em português</a></p>",
      },
      { type: "greeting", enabled: true },
      {
        type: "heading",
        eyebrow: "",
        title: "New reporting rules for crypto assets in Brazil",
        lead:
          "The Central Bank of Brazil has issued new rules on the reporting of crypto assets. The first of these will take effect on 1 October 2026. We have set out the main points below for clients who hold assets with exchanges operating in Brazil.",
      },
      {
        type: "facts",
        items: [
          { label: "1 October 2026", value: "Coaf reporting", note: "Transfers to or from self custody wallets" },
          { label: "Threshold", value: "US$10,000", note: "Per transfer, or the equivalent" },
        ],
      },
      {
        type: "section",
        title: "What changes on 1 October 2026",
        html: "<p>Authorised virtual asset service providers in Brazil must report to Coaf, the Financial Activities Control Council, any transfer of crypto assets of US$10,000 or more, or the equivalent, that is sent to a wallet, or even to wallets described as self custody, or that is received through one of them.</p><p>This amount is not an authorisation to move funds without oversight, and it is not a maximum transfer limit. It is a mandatory reporting trigger. The operation may still be carried out, but it must be reported to the competent authorities.</p>",
      },
      {
        type: "section",
        title: "Wallets offered by exchanges",
        html: "<p>Exchanges are informing their clients that all crypto asset wallets, including wallets described as self custody, are not exempt from this reporting. The rule therefore also covers assets already deposited in these wallets.</p>",
      },
      {
        type: "section",
        title: "Self custody wallets",
        html: "<p>Wallets described as self custody that are offered by exchanges operating in Brazil may continue to be used. However, they will not be exempt from the reporting, monitoring or declaration obligations that apply in Brazil. These wallets can carry out on-chain transactions, but they remain linked to the ecosystem of these exchanges operating in Brazilian territory. They are therefore subject to compliance controls, identification of origin and destination, and transaction monitoring.</p>",
      },
      { type: "divider" },
      {
        type: "note",
        html: "<p>Source: Banco Central do Brasil, <a href=\"https://www.bcb.gov.br/detalhenoticia/21267/nota\">press note of 23 September 2026</a> on Resolução BCB nº 588/2026.</p><p>This communication is provided for general information only. It does not constitute legal or tax advice.</p>",
      },
    ]),
  },
  {
    id: "binance_brazil_migration_oct2026",
    label: "Binance & Crypto.com Brazil, October 2026",
    description:
      "Note for clients who hold assets with Binance or Crypto.com. Local structure (Binance), BRL account closure (Crypto.com), tax and reporting. Do not send until approved.",
    subject: "Binance and Crypto.com in Brazil: changes in October 2026",
    eyebrow: "REGULATORY UPDATE",
    blocks: withIds([
      {
        type: "note",
        html: "<p><a href=\"https://fiddux.com/exchanges-brasil-outubro-update-2026\">Leia este comunicado em português</a></p>",
      },
      { type: "greeting", enabled: true },
      {
        type: "heading",
        eyebrow: "",
        title: "Binance and Crypto.com: changes for clients residing in Brazil",
        lead:
          "Binance and Crypto.com have announced changes for clients residing in Brazil in October 2026. By 29 October, Binance will complete the transfer of those clients to Brazilian companies in its group. On 25 October, Crypto.com will close the reais (BRL) account. Crypto trading and the card will remain available. We have set out below what changes on each platform. Your Fiddux account is not affected.",
      },
      {
        type: "facts",
        items: [
          { label: "Binance", value: "Brazilian companies", note: "29 October 2026 · Reais, Pix and local virtual-asset services" },
          { label: "Crypto.com", value: "BRL account closes", note: "25 October 2026 · Crypto trading and the card continue" },
        ],
      },
      {
        type: "section",
        title: "Binance — Brazilian companies by 29 October",
        html: "<p>By 29 October 2026, a client residing in Brazil will hold an individual payment account with Binance Brasil Corretora de Câmbio e Valores Mobiliários S.A. The Central Bank of Brazil approved the transfer of control of that brokerage to the Binance group. The decision was published on 31 December 2024. Deposits and withdrawals in reais, including Pix, will be made through this account.</p><p>Virtual-asset services authorised in Brazil will be provided by BBrasil Sociedade Prestadora de Serviços de Ativos Virtuais Ltda., a company in the same group.</p><p>From that date, disposals of virtual assets on the Brazilian company follow the capital-gains rules that apply in Brazil. The gain is exempt from income tax when the total disposed of in the month does not exceed R$35,000. If that monthly total is exceeded, the exemption does not apply, and the entire gain for the month is taxed.</p><p>The Brazilian company reports to the Federal Revenue Service the operations carried out in Brazil, under Normative Instruction RFB No. 2,291/2025 (DeCripto).</p><p>Binance will not offer derivatives, including futures, to clients residing in Brazil. A client who already uses these products, or who chooses to use them of their own accord, may do so only on a separate international account of Binance's company in Abu Dhabi (ADGM).</p>",
      },
      {
        type: "section",
        title: "Crypto.com — the BRL account closes on 25 October",
        html: "<p>From 25 October 2026, Crypto.com will no longer offer the BRL account to users in Brazil. After that date it will not be possible to deposit reais from a verified personal bank account, to withdraw reais to that account, or to trade reais directly against crypto in the app.</p><p>Before 25 October, Crypto.com recommends withdrawing any BRL balance to a verified bank account, or converting it to crypto in the app. Limit orders, recurring purchases and TWAP orders funded by the BRL account will be cancelled on 25 October. Any reais balance remaining after the deadline will be converted automatically to USDC at the market rate then in force, and credited to the client's crypto wallet.</p><p>From that date, disposals of virtual assets on the platform follow the capital-gains rules that apply in Brazil. The gain is exempt from income tax when the total disposed of in the month does not exceed R$35,000. If that monthly total is exceeded, the exemption does not apply, and the entire gain for the month is taxed.</p><p>Crypto.com states that crypto deposits and withdrawals, trading between crypto assets, staking terms and the Visa card are not affected by the closure of the BRL account. The terms for Brazil have been updated. Continued use of the app after 25 October is acceptance of those terms.</p>",
      },
      { type: "divider" },
      {
        type: "note",
        html: "<p>Sources: Binance, <a href=\"https://www.binance.com/pt-BR/support/faq/detail/d79576b30c8240118a043129e0c21398\">Binance Brasil: entenda as mudanças nos nossos serviços</a> (8 October 2026); Crypto.com, <a href=\"https://help.crypto.com/pt-BR/articles/16858433-encerramento-da-conta-em-brl\">Encerramento da Conta em BRL</a>.</p><p>This communication is provided for general information only. It does not constitute legal or tax advice.</p>",
      },
    ]),
  },
  {
    id: "yield_usdc_hours",
    label: "Yield · USDC · operating hours",
    description: "Institutional announcement — do not send to clients until approved.",
    subject: "Fiddux — Updates to your experience: Yield, USDC & operating hours",
    eyebrow: "CLIENT UPDATE",
    blocks: withIds([
      { type: "hero", url: "", alt: "Fiddux", link: "" },
      { type: "greeting", enabled: true },
      {
        type: "heading",
        eyebrow: "",
        title: "Updates to your Fiddux experience",
        lead:
          "We are writing to share a small number of enhancements now available to you. Each is designed to give you greater flexibility while preserving the same standard of care and discretion you expect from Fiddux.",
      },
      {
        type: "section",
        title: "Yield",
        html: "<p>Our Yield product is now available for eligible clients, offering a clear way to put idle balances to work under transparent terms. You may review the details and opt in directly from the Fiddux app at your convenience.</p>",
      },
      {
        type: "section",
        title: "USDT & USDC",
        html: "<p>In addition to USDT, we now accept <strong>USDC</strong> for deposits and withdrawals — giving you more choice in how you move funds, without changing the security standards of our process.</p>",
      },
      {
        type: "section",
        title: "Operating hours",
        html: "<p>Withdrawal processing now follows a defined operating window (<strong>09:00–21:00 Europe/London</strong>), so every request receives the oversight it deserves within clear, predictable hours.</p>",
      },
      {
        type: "facts",
        items: [
          { label: "Yield", value: "Now available", note: "Opt in from the app" },
          { label: "USDC", value: "Accepted", note: "Deposits and withdrawals" },
          { label: "Hours", value: "09:00–21:00", note: "Europe/London" },
        ],
      },
      {
        type: "text",
        html: "<p>If you have any questions, simply reply to this email — our team will be glad to assist.</p>",
      },
      { type: "button", label: "Open Fiddux", url: "https://fiddux.com", align: "center" },
    ]),
  },
  {
    id: "client_update_blank",
    label: "Client update",
    description: "Blank institutional announcement.",
    subject: "Fiddux — Client update",
    eyebrow: "CLIENT UPDATE",
    blocks: withIds([
      { type: "greeting", enabled: true },
      { type: "heading", eyebrow: "", title: "", lead: "" },
      { type: "text", html: "<p></p>" },
      { type: "button", label: "Open Fiddux", url: "https://fiddux.com", align: "center" },
    ]),
  },
  {
    id: "operational_notice",
    label: "Operational notice",
    description: "Short notice for hours, processing, or service updates.",
    subject: "Fiddux — Operational notice",
    eyebrow: "OPERATIONAL NOTICE",
    blocks: withIds([
      { type: "greeting", enabled: true },
      {
        type: "heading",
        eyebrow: "",
        title: "A brief operational update",
        lead: "We are writing to let you know about a change that may affect how we process requests.",
      },
      { type: "text", html: "<p>Please find the details below. If you have any questions, reply to this email and our team will assist.</p>" },
      { type: "button", label: "Open Fiddux", url: "https://fiddux.com", align: "center" },
    ]),
  },
  {
    id: "birthday",
    label: "Birthday wishes",
    description: "Short personal note on a client’s birthday.",
    subject: "Fiddux — Birthday wishes",
    eyebrow: "WITH OUR COMPLIMENTS",
    blocks: withIds([
      { type: "hero", url: HERO.birthday, alt: "A quiet note", link: "" },
      { type: "greeting", enabled: true },
      {
        type: "heading",
        eyebrow: "",
        title: "A note on your birthday",
        lead: "We simply wished to mark the day — with the same discretion we bring to everything else.",
      },
      {
        type: "text",
        html: "<p>On behalf of everyone at Fiddux, we send our warmest wishes for the year ahead. May it be healthy, considered, and entirely your own.</p><p>If we may be of any assistance — today or on any other day — you need only reply to this email.</p>",
      },
      { type: "button", label: "Open Fiddux", url: "https://fiddux.com", align: "center" },
    ]),
  },
  {
    id: "christmas",
    label: "Christmas",
    description: "Season’s greetings — quiet, not promotional.",
    subject: "Fiddux — Season's greetings",
    eyebrow: "SEASON'S GREETINGS",
    blocks: withIds([
      { type: "hero", url: HERO.christmas, alt: "Winter evening", link: "" },
      { type: "greeting", enabled: true },
      {
        type: "heading",
        eyebrow: "",
        title: "Warm wishes for Christmas",
        lead: "As the year grows quiet, we wanted to send a brief note of thanks — for the confidence you place in Fiddux.",
      },
      {
        type: "text",
        html: "<p>We hope the days ahead offer rest, good company, and a little distance from the ordinary pace of things.</p><p>Our team remains available should you need us. Until then, we wish you a peaceful Christmas.</p>",
      },
      { type: "button", label: "Open Fiddux", url: "https://fiddux.com", align: "center" },
    ]),
  },
  {
    id: "new_year",
    label: "New Year",
    description: "NYE / New Year — a calm wish for the year ahead.",
    subject: "Fiddux — A wish for the year ahead",
    eyebrow: "NEW YEAR",
    blocks: withIds([
      { type: "hero", url: HERO.newYear, alt: "The year ahead", link: "" },
      { type: "greeting", enabled: true },
      {
        type: "heading",
        eyebrow: "",
        title: "For the year ahead",
        lead: "As one year closes and another begins, we send our best wishes — quietly, and with genuine regard.",
      },
      {
        type: "text",
        html: "<p>May the months ahead bring clarity, good health, and the space to decide what matters.</p><p>Fiddux will continue to serve you with the same care and discretion. If you wish to speak as the year opens, we are here.</p>",
      },
      { type: "button", label: "Open Fiddux", url: "https://fiddux.com", align: "center" },
    ]),
  },
  {
    id: "chinese_new_year",
    label: "Lunar New Year",
    description: "Chinese / Lunar New Year — restrained seasonal note.",
    subject: "Fiddux — Wishes for the Lunar New Year",
    eyebrow: "LUNAR NEW YEAR",
    blocks: withIds([
      { type: "hero", url: HERO.cny, alt: "Plum blossom", link: "" },
      { type: "greeting", enabled: true },
      {
        type: "heading",
        eyebrow: "",
        title: "Wishes for the Lunar New Year",
        lead: "We write to mark the turning of the year, and to send our respects for the days ahead.",
      },
      {
        type: "text",
        html: "<p>May the new year bring health, composure, and prosperity in the measure you choose.</p><p>It is a privilege to serve you. If we can be of help as the year begins, simply reply to this email.</p>",
      },
      { type: "button", label: "Open Fiddux", url: "https://fiddux.com", align: "center" },
    ]),
  },
  {
    id: "easter",
    label: "Easter",
    description: "A brief spring note — no promotion.",
    subject: "Fiddux — A note for Easter",
    eyebrow: "EASTER",
    blocks: withIds([
      { type: "hero", url: HERO.easter, alt: "Spring light", link: "" },
      { type: "greeting", enabled: true },
      {
        type: "heading",
        eyebrow: "",
        title: "A note for Easter",
        lead: "A short message, only: we hope these days bring rest and a change of pace.",
      },
      {
        type: "text",
        html: "<p>Whether you observe Easter or simply take the quieter days, we wish you time well spent — with those who matter, and on your own terms.</p><p>Our team remains at your disposal. With kind regards from everyone at Fiddux.</p>",
      },
      { type: "button", label: "Open Fiddux", url: "https://fiddux.com", align: "center" },
    ]),
  },
  {
    id: "year_end",
    label: "Year-end note",
    description: "Close of year — thanks, not a performance report.",
    subject: "Fiddux — A note as the year closes",
    eyebrow: "YEAR END",
    blocks: withIds([
      { type: "hero", url: HERO.yearEnd, alt: "Year’s close", link: "" },
      { type: "greeting", enabled: true },
      {
        type: "heading",
        eyebrow: "",
        title: "As the year closes",
        lead: "Before the calendar turns, we wanted to thank you for the trust you place in Fiddux.",
      },
      {
        type: "text",
        html: "<p>It has been our privilege to look after your affairs with care. We do not take that lightly.</p><p>We remain available through the close of the year and into the next. If there is anything you wish to review, or simply to discuss, reply to this email and we will be glad to assist.</p>",
      },
      { type: "button", label: "Open Fiddux", url: "https://fiddux.com", align: "center" },
    ]),
  },
];

export function clonePreset(preset) {
  if (!preset) return null;
  return {
    subject: preset.subject || "",
    eyebrow: preset.eyebrow || "CLIENT UPDATE",
    blocks: (preset.blocks || []).map((b) => ({
      ...createBlock(b.type),
      ...JSON.parse(JSON.stringify(b)),
      id: createBlock(b.type).id,
    })),
  };
}

export function findPreset(id) {
  return CAMPAIGN_PRESETS.find((p) => p.id === id) || null;
}
